export default __webpack_public_path__ + "bing-fallback-m.05a1ff7157dc69ce0d4f4b120d49d9b5.png";